var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiconBuild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 28V4L5 4L5 28H21Z",
    stroke: "#A1A1A1",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 28V11H21V28H27Z",
    stroke: "#A1A1A1",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10H18V7H15V10Z",
    stroke: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15H18V12H15V15Z",
    stroke: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 20H18V17H15V20Z",
    stroke: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 25H11V22H8V25Z",
    stroke: "#73B8FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiconBuild);
export default __webpack_public_path__ + "static/media/dicon_build.1c2f51d861d3aebdfa6b9f30315682c6.svg";
export { ForwardRef as ReactComponent };